ACC.detailsQuote = {

    _autoload: [
		"bindCancelQuote",
        "bindContactAgency",
		"triggerRfq",
	],

    bindCancelQuote: function () {
        $(document).on("click",".js-cancel-quote",function(e){
            e.preventDefault();
            ACC.detailsQuote.cancelQuote();
		});

        $(".wrapper-reason.checked").find("input").prop( "checked", true);
    },

    cancelQuote: function () {
        var title = $('#cancelQuote').data("cancelTitle");

        ACC.colorbox.open("", {
            href: "#cancelQuote",
            inline: true,
            width: "600px",
			height: "460px",
            
            onComplete: function () {
                $(document).on("submit", '#cancelCartForm', function () {

                    var $form = $('#cancelQuote .formPopupcancel');
                        window.location.replace(url);
                        this.submit();
                });
            },
            onClosed: function () {
                
            }
        });
    },


    bindContactAgency: function () {
        $(document).on("click", ".js-agency", function (e) {
            e.preventDefault();

            ACC.detailsQuote.contactAgency();

            const $this = $(this);
            const mailItem = $this.siblings(".mailItem").text().trim() || $this.data("mailitem");
            const poNumber = $this.closest("tr").find(".paddingScale:eq(1)").text().trim() || "";

            $("#wrapperContactAgency #contactAgency #email").val(mailItem);
            $("#wrapperContactAgency #contactAgency input#code").val(poNumber);
        });


    },

    contactAgency: function () {
        var title = $('#wrapperContactAgency').data("cancelTitle");

        ACC.colorbox.open("", {
            href: "#wrapperContactAgency",
            inline: true,
            width: "600px",
			height: "430px",
            
            onComplete: function () {
                $(document).on("submit", '#contactAgency', function () {
                    var $form = $('#wrapperContactAgency .formContactAgency');
                    $.ajax({
                        url: $form.attr("action"),
                        data: $form.serialize(),
                        type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                        success: function () {
                            var url = ACC.config.encodedContextPath + "/my-account/my-quotes"
                            window.location.replace(url);
                        },
                        error: function () {
                          alert("Failed");
                        }
                    });
                    return false;
                });
            },
        });
    },


    triggerRfq: function () {
        $(document).on("click",".js-trigger-popup",function(e){
            e.preventDefault();
            ACC.detailsQuote.saveFormRfq();
             /* Contentsquare */
                ACC.track.contentsquareAPVTracking("rfq-request-additional-products");
            /* Contentsquare */
        });      
        
        setTimeout(function () {
            if($(".js-trigger-popup")){
                $(".js-trigger-popup").click();
            }
        }, 1500);
    },

    saveFormRfq: function () {
        if (ACC.savedcarts.referenceRfqVal) {
			ACC.savedcarts.valref = $('.js-reference-rfq').val();
			ACC.savedcarts.referenceRfqVal = false;
		}
        var title = $('.confirmRfq').data("saveCartTitle");
        ACC.colorbox.open("", {
            href: ".confirmRfq",
            inline: true,
            width: "885px",
			height: "650px",
            
            onComplete: function () {
                var maxHeight = 0;
    
                $(".list-prod-rfq tbody .single-item:lt(3)").each(function() {
                    maxHeight += $(this).outerHeight();
                    console.log(maxHeight);
                });
    
                $(".list-prod-rfq tbody").css("max-height", maxHeight+"px");
                
                if($(".list-prod-rfq tbody .single-item").length > 3) {
                    $(".list-prod-rfq tbody").perfectScrollbar({
                        useBothWheelAxes: false,
                        suppressScrollX: true
                    });
                }

                var maxValInit = $(".commentRfq").attr("maxlength");
				console.log("max val :",maxValInit);
				$('#charNumRfq span').text(maxValInit);
				$(".commentRfq").keyup(function () {
					var len = $(this).val().length;
					var maxVal = $(this).attr("maxlength");
					if (len >= maxVal) {
						$(this).val($(this).val().substring(0, maxVal));
						$('#charNumRfq span').text(0);
					} else {
						$('#charNumRfq span').text(maxVal - len);
					}
				});
                
                function isValidDate(input) {
					var regEx;
					if ($(".lang-current").text() == "de") {
						 regEx = /^([0-2][0-9]|(3)[0-1])(\.)(((0)[0-9])|((1)[0-2]))(\.)\d{4}$/;
					} else if ($(".lang-current").text() == "nl") {
						regEx = /^([0-2][0-9]|(3)[0-1])(\-)(((0)[0-9])|((1)[0-2]))(\-)\d{4}$/;
					}else {
						 regEx = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
					}
					return input.match(regEx) != null;
				}
                
                $(document).on("submit", '.rfqForm', function (e) {
                    e.preventDefault();
                    var givenValue = $(".confirmRfq #desiredDeliveryDate").val();
					if(givenValue != "" && !isValidDate(givenValue)){
						$(".confirmRfq #desiredDeliveryDate").val("");
						$(".confirmRfq #desiredDeliveryDate").closest(".datedelivery").addClass("invalid");
					} else {
						$(".confirmRfq #desiredDeliveryDate").closest(".datedelivery").removeClass("invalid");
                    
                        var $form = $('.confirmRfq .rfqForm');
                        var $referenceRfq = $('.js-reference-rfq').val();
                        if ($referenceRfq != "") {
                            $(".without-ref-rfq").addClass("hidden");
                            $(".with-ref-rfq").removeClass("hidden");
                            $(".with-ref-rfq .ref-text").text(" "+$referenceRfq);
                        }else {
                            $(".with-ref-rfq").addClass("hidden");
                            $(".without-ref-rfq").removeClass("hidden");
                        }
                        $.ajax({
                            url: $form.attr("action"),
                            data: $form.serialize(),
                            type: $form.attr("method") ? $form.attr("method").toUpperCase() : "GET",
                            success: function () {
                                
                                ACC.colorbox.open(title="", {
                                    href: "#successSaveCart",
                                    inline: true,
                                    width: "600px",
                                    height: "400px",
                                    onClosed: function() {
                                        // var url = ACC.config.encodedContextPath + "/my-account/my-quotes"
                                        // window.location.replace(url);
                                    },
                                    onComplete: function () {
                                        $(".js-btn-redirect").on("click", function () {
                                            ACC.colorbox.close();
                                        });
                                    },
                                });
                            },
                            error: function () {
                            alert("Failed !!");
                            }
                        });
                        return false;
                    }
                });
            },
            onClosed: function() {
                $(document).off("submit", '.rfqForm');
                $(".confirmRfq .js-reference-rfq").val(ACC.savedcarts.valref);
				$(".confirmRfq #desiredDeliveryDate").closest(".datedelivery").removeClass("invalid");
				$(".confirmRfq #desiredDeliveryDate").val("");
				$(".confirmRfq #comment").val("");
				$(".confirmRfq .chooseDeal").load(location.href + " .confirmDevis .chooseDeal");
            },
        });
    }

}